import React from "react";
import { useTable, usePagination } from "react-table";
import FHIRDetails from "../FHIRDetails";
import NewPagination from "../NewPagination";

import styles from "./SearchResultDatatable.module.scss";

const SearchResultDatatable = ({ columns, data, rowClick, expandedArray }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state,
    prepareRow
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 }
    },
    usePagination
  );
  const { pageIndex } = state;
  return (
    <div className={styles.base}>
      <NewPagination
        resultsCount={data.length}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        previousPage={previousPage}
        nextPage={nextPage}
      />
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {data.length === 0 ? (
            <tr>
              <td style={{ textAlign: "center" }} colSpan={columns.length}>
                No data to show
              </td>
            </tr>
          ) : (
            page.map((row, index) => {
              prepareRow(row);
              return (
                <React.Fragment key={index}>
                  <tr
                    className={`${
                      expandedArray.filter(
                        expanded => expanded.id === row.original.id
                      )[0].expanded
                        ? styles.highlighted
                        : ""
                    }`}
                    {...row.getRowProps()}
                    onClick={() => rowClick(row.original.id)}
                  >
                    {row.cells.map(cell => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                  {expandedArray ? (
                    expandedArray.filter(
                      expanded => expanded.id === row.original.id
                    )[0].expanded ? (
                      <tr className={styles.expandedRow}>
                        <td colSpan={10}>
                          <FHIRDetails patient={row.original} />
                        </td>
                      </tr>
                    ) : null
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SearchResultDatatable;
